module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_background"
  }, [_c('div', {
    staticClass: "vertical_level"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "login-wrap"
  }, [_c('div', {
    staticClass: "Icons_selection_boxes Icons_selection_item"
  }, [_c('img', {
    staticClass: "icon_flev",
    attrs: {
      "src": require("./images/user.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.uc),
      expression: "loginForm.uc"
    }],
    staticClass: "a1",
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.loginForm.uc)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "uc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Icons_selection_boxes_two Icons_selection_item"
  }, [_c('img', {
    staticClass: "icon_flev",
    attrs: {
      "src": require("./images/possword.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.pwd),
      expression: "loginForm.pwd"
    }],
    staticClass: "a1",
    attrs: {
      "type": "password",
      "placeholder": "请输入密码",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.loginForm.pwd)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.loginForm, "pwd", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sign_in",
    on: {
      "click": _vm.login
    }
  }, [_c('button', {
    staticClass: "login_btn"
  }, [_vm._v("登录")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical_level_size"
  }, [_c('img', {
    attrs: {
      "src": require("./images/logo002.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-200e8b6c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/ssoLogin.vue
// module id = 1323
// module chunks = 5